/* raw layout hash: _tenant-users-access-management-layout:5e1c3c9996c32f1a72606e93e958b5f95eb430382b2e7e11bada3216f4da7a88 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_tenant-users-access-management-layout" — renders its page content through the router outlet.
export default function TenantUsersAccessManagementLayout() {
  return <AppShell layoutName="_tenant-users-access-management-layout" menu={LAYOUT_MENUS['_tenant-users-access-management-layout']} />;
}
